export default {
  // Hero section
  'hero.title': 'Herramientas de Temporizador en Línea Profesionales',
  'hero.subtitle': 'Elija la herramienta de cronometraje perfecta para sus necesidades',

  // Tool cards
  'timer.title': 'Temporizador',
  'timer.description': 'Temporizador de cuenta regresiva para trabajo, estudio y vida',
  'timer.longDescription': 'Temporizador de cuenta regresiva para productividad, cocina y gestión del tiempo',
  'timer.button': 'Iniciar Temporizador',

  'stopwatch.title': 'Cronómetro',
  'stopwatch.description': 'Herramienta de cronometraje de alta precisión',
  'stopwatch.longDescription': 'Cronómetro de alta precisión para deportes, entrenamiento y cronometraje preciso',
  'stopwatch.button': 'Iniciar Cronómetro',

  'worldclock.title': 'Reloj Mundial',
  'worldclock.description': 'Ver zonas horarias de todo el mundo',
  'worldclock.longDescription': 'Visualización en tiempo real de las horas de las principales ciudades del mundo con cálculos inteligentes de zonas horarias',
  'worldclock.button': 'Ver Reloj Mundial',

  // Features section
  'features.title': '¿Por Qué Elegir timer.today?',
  'features.reliable.title': 'Confiable y Preciso',
  'features.reliable.desc': 'Cronometraje de precisión de milisegundos con confiabilidad basada en navegador',
  'features.crossPlatform.title': 'Multiplataforma',
  'features.crossPlatform.desc': 'Funciona perfectamente en escritorio, tableta y dispositivos móviles',
  'features.smartNotifications.title': 'Notificaciones Inteligentes',
  'features.smartNotifications.desc': 'Alertas de sonido y notificaciones de escritorio cuando se agota el tiempo',
  'features.easyToUse.title': 'Fácil de Usar',
  'features.easyToUse.desc': 'Interfaz limpia con controles intuitivos para todos los usuarios',

  // Keywords section
  'keywords.timer': 'temporizador cuenta regresiva pomodoro concentración trabajo descanso',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
